import { render, staticRenderFns } from "./CapturaDocumentoVerso.vue?vue&type=template&id=2a94f869&scoped=true&"
import script from "./CapturaDocumentoVerso.vue?vue&type=script&lang=js&"
export * from "./CapturaDocumentoVerso.vue?vue&type=script&lang=js&"
import style0 from "./CapturaDocumentoVerso.vue?vue&type=style&index=0&id=2a94f869&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a94f869",
  null
  
)

export default component.exports